export default [
    {
        component: () => import(/* webpackChunkName: 'ambulatorio-jornada-situacao' */ '@/views/ambulatorio/jornada-situacao/Index'),
        path: 'jornada-situacao',
        redirect: 'jornada-situacao/index',
        children: [
            {
                component: () => import(/* webpackChunkName: 'ambulatorio-jornada-situacao' */'@/views/ambulatorio/jornada-situacao/List.vue'),
                name: 'ambulatorio-jornada-situacao-index',
                path: 'index',
            },
            {
                component: () => import(/* webpackChunkName: 'ambulatorio-jornada-situacao' */ '@/views/ambulatorio/jornada-situacao/Form.vue'),
                name: 'ambulatorio-jornada-situacao-create',
                path: 'create',
            },
            {
                component: () => import(/* webpackChunkName: 'ambulatorio-jornada-situacao' */ '@/views/ambulatorio/jornada-situacao/Form.vue'),
                name: 'ambulatorio-jornada-situacao-edit',
                path: 'edit/:id',
                props: route => ({ id: parseInt(route.params.id) }),
            },
        ],
    },
]